export default __webpack_public_path__ + "static/3-b7924278b9bf62e005d71889ecdccfd9.png";